import React from "react";
import JoditEditor from "jodit-react";
import { useMemo } from "react";

function JoditEditior({ content, setContent }) {
  const config = useMemo(() => ({ minHeight: 300 }), []);

  return (
    <div style={{ width: "100%" }}>
      <div className="text-editor">
        {/* <JoditEditor
          value={content}
          tabIndex={1}
          onBlur={(newContent) => {
            if (newContent !== content) {
              setContent(newContent);
            }
          }}
          config={{
            minHeight: 300,
          }}
        /> */}
        <JoditEditor
          value={content}
          tabIndex={1}
          onBlur={(newContent) => {
            if (newContent !== content) setContent(newContent);
          }}
          config={config}
        />
      </div>
    </div>
  );
}

export default JoditEditior;
